import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ContactAction from "../DetailsFooter/ContactAction";
import {StyledPhoneAndroidIcon, StyledPhoneEnabledIcon} from "../../styled";

export interface AddressProps {
    postCode: string
    city: string
    street?: string
    houseNumber?: string
    streetHouseNumber?: string
    country: string
    phone: string
    mobile: string
    fax: string
    recruitIsCompany: boolean
}

const BasedataAddress: React.FC<AddressProps> = (props) => {

    const {postCode, country, fax, houseNumber, mobile, phone, street, city, recruitIsCompany, streetHouseNumber} = props;

    return (
        <Box sx={{mb: recruitIsCompany ? 3 : 0, display: "flex", flexDirection: "column", flexWrap: "wrap",}}>
            { !streetHouseNumber && street && houseNumber && <Typography variant="body1">{street} {houseNumber}</Typography>}
            { streetHouseNumber && <Typography variant="body1">{streetHouseNumber}</Typography>}
            { postCode && city && country && <Typography variant="body1">{postCode} {city}, ({country})</Typography>}
            { country && <Typography variant="body1" sx={{mb: 1}}>{country}</Typography>}
            { phone && <ContactAction href={phone} Icon={ <StyledPhoneEnabledIcon />} type="tel"/> }
            { mobile && <ContactAction href={mobile} Icon={ <StyledPhoneAndroidIcon />} type="tel"/> }
            { fax && <Typography variant="body1">{fax}</Typography>}
        </Box>
    );
};

export default BasedataAddress;